import { Action, createReducer, on } from '@ngrx/store';
import { InventoryStore } from '../models/store/inventory/inventoryStore';

import {
  loadDoctorSpecialization,
  addDoctorSpecialization,
  startInventoryFetch,
  stopInventoryFetch,
  removeDoctorSpecializations,
  removeAllDoctorSpecializations,
  loadLabTest,
  addLabTest,
  removeLabTests,
  removeAllLabTests,
  loadLabTestPackages,
  addLabTestPackage,
  removeLabTestPackages,
  removeAllLabTestPackages,
  addAilment,
  addHospitalization,
  addStaticReason,
  loadAilments,
  loadHospitalizations,
  loadStaticReasons,
  removeAilments,
  removeAllAilments,
  removeAllHospitalizations,
  removeAllStaticReasons,
  removeHospitalizations,
  removeStaticReasons,
  editDoctorSpecialization,
  editLabTest,
  editLabTestPackage,
  editHospitalization,
  editAilment,
  editStaticReason,
  paginateInventory,
  loadPharmacyTest,
  addPharmacyTest,
  editPharmacyTest,
  removePharmacyTest,
  removeAllPharmacyTest
} from '../actions/inventory/inventory.action';

export const initialState: InventoryStore = {
  fetching: false,
  data: {
    ailments: [],
    labTests: [],
    staticReasons: [],
    labTestPackages: [],
    hospitalizations: [],
    doctorSpecializations: [],
    pharmacyServices: [],
    totalDocuments: {
      ailments: 0,
      labTests: 0,
      pharmacyServices: 0,
      staticReasons: 0,
      labTestPackages: 0,
      hospitalizations: 0,
      doctorSpecializations: 0
    },
  }
};

const inventoryReducer = createReducer(initialState,
  /** Doctor Specializations */
  on(loadDoctorSpecialization, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        doctorSpecializations: [
          ...state.data.doctorSpecializations,
          ...payload.filter(p => !state.data.doctorSpecializations.find(ds => ds._id === p._id))
        ],
        totalDocuments: {
          ...state.data.totalDocuments,
          doctorSpecializations: totalDocuments
        },
      }
    })
  ),
  on(addDoctorSpecialization, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        doctorSpecializations: [payload,
          ...(state.data.doctorSpecializations.length === 10
            ? state.data.doctorSpecializations.slice(0, state.data.doctorSpecializations.length - 1)
            : state.data.doctorSpecializations)],
        totalDocuments: {
          ...state.data.totalDocuments,
          doctorSpecializations: state.data.totalDocuments.doctorSpecializations + 1
        },
      }
    })
  ),
  on(editDoctorSpecialization, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        doctorSpecializations: state.data.doctorSpecializations.map(
          data => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removeDoctorSpecializations, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        doctorSpecializations: state.data.doctorSpecializations
          .filter(d => !payload.includes(String(d._id))),
        totalDocuments: {
          ...state.data.totalDocuments,
          doctorSpecializations: state.data.totalDocuments.doctorSpecializations - 1
        },
      }
    })
  ),
  on(removeAllDoctorSpecializations, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        doctorSpecializations: [],
        totalDocuments: {
          ...state.data.totalDocuments,
          doctorSpecializations: 0
        },
      }
    })
  ),

  // Lab _tests
  on(loadLabTest, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        labTests: [
          ...state.data.labTests,
          ...payload.filter(p => !state.data.labTests.find(lt => lt._id === p._id))
        ],
        totalDocuments: {
          ...state.data.totalDocuments,
          labTests: totalDocuments
        },
      }
    })
  ),
  on(addLabTest, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        labTests: [payload,
          ...(state.data.labTests.length === 10
            ? state.data.labTests.slice(0, state.data.labTests.length - 1)
            : state.data.labTests)],
        totalDocuments: {
          ...state.data.totalDocuments,
          labTests: state.data.totalDocuments.labTests + 1
        },
      }
    })
  ),
  on(editLabTest, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        labTests: state.data.labTests.map(
          data => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removeLabTests, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        labTests: state.data.labTests
          .filter(d => !payload.includes(String(d._id))),
        totalDocuments: {
          ...state.data.totalDocuments,
          labTests: state.data.totalDocuments.labTests - 1
        },
      }
    })
  ),
  on(removeAllLabTests, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        labTests: [],
        totalDocuments: {
          ...state.data.totalDocuments,
          labTests: 0
        },
      }
    })
  ),

  // Lab tests
  on(loadLabTestPackages, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        labTestPackages: [
          ...state.data.labTestPackages,
          ...payload.filter(p => !state.data.labTestPackages.find(ltp => ltp._id === p._id))
        ],
        totalDocuments: {
          ...state.data.totalDocuments,
          labTestPackages: totalDocuments
        },
      }
    })
  ),
  on(addLabTestPackage, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        labTestPackages: [payload,
          ...(state.data.labTestPackages.length === 10
            ? state.data.labTestPackages.slice(0, state.data.labTestPackages.length - 1)
            : state.data.labTestPackages)],
        totalDocuments: {
          ...state.data.totalDocuments,
          labTestPackages: state.data.totalDocuments.labTestPackages + 1
        },
      }
    })
  ),
  on(editLabTestPackage, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        labTestPackages: state.data.labTestPackages.map(
          data => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removeLabTestPackages, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        labTestPackages: state.data.labTestPackages
          .filter(d => !payload.includes(String(d._id))),
        totalDocuments: {
          ...state.data.totalDocuments,
          labTestPackages: state.data.totalDocuments.labTestPackages - 1
        },
      }
    })
  ),
  on(removeAllLabTestPackages, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        labTestPackages: [],
        totalDocuments: {
          ...state.data.totalDocuments,
          labTestPackages: 0
        },
      }
    })
  ),

  // Hospitalizations
  on(loadHospitalizations, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        hospitalizations: [
          ...state.data.hospitalizations,
          ...payload.filter(p => !state.data.hospitalizations.find(h => h._id === p._id))
        ],
        totalDocuments: {
          ...state.data.totalDocuments,
          hospitalizations: totalDocuments
        },
      }
    })
  ),
  on(addHospitalization, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        hospitalizations: [payload,
          ...(state.data.hospitalizations.length === 10
            ? state.data.hospitalizations.slice(0, state.data.hospitalizations.length - 1)
            : state.data.hospitalizations)],
        totalDocuments: {
          ...state.data.totalDocuments,
          hospitalizations: state.data.totalDocuments.hospitalizations + 1
        },
      }
    })
  ),
  on(editHospitalization, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        hospitalizations: state.data.hospitalizations.map(
          data => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removeHospitalizations, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        hospitalizations: state.data.hospitalizations
          .filter(d => !payload.includes(String(d._id))),
        totalDocuments: {
          ...state.data.totalDocuments,
          hospitalizations: state.data.totalDocuments.hospitalizations - 1
        },
      }
    })
  ),
  on(removeAllHospitalizations, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        hospitalizations: [],
        totalDocuments: {
          ...state.data.totalDocuments,
          hospitalizations: 0
        },
      }
    })
  ),


  // Static Reasons
  on(loadStaticReasons, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        staticReasons: [
          ...state.data.staticReasons,
          ...payload.filter(p => !state.data.staticReasons.find(sr => sr._id === p._id))
        ],
        totalDocuments: {
          ...state.data.totalDocuments,
          staticReasons: totalDocuments
        },
      }
    })
  ),
  on(addStaticReason, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        staticReasons: [payload,
          ...(state.data.staticReasons.length === 10
            ? state.data.staticReasons.slice(0, state.data.staticReasons.length - 1)
            : state.data.staticReasons)],
        totalDocuments: {
          ...state.data.totalDocuments,
          staticReasons: state.data.totalDocuments.staticReasons + 1
        },
      }
    })
  ),
  on(editStaticReason, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        staticReasons: state.data.staticReasons.map(
          data => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removeStaticReasons, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        staticReasons: state.data.staticReasons
          .filter(d => !payload.includes(String(d._id))),
        totalDocuments: {
          ...state.data.totalDocuments,
          staticReasons: state.data.totalDocuments.staticReasons - 1
        },
      }
    })
  ),
  on(removeAllStaticReasons, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        staticReasons: [],
        totalDocuments: {
          ...state.data.totalDocuments,
          staticReasons: 0
        },
      }
    })
  ),

  // Ailments
  on(loadAilments, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        ailments: [
          ...state.data.ailments,
          ...payload.filter(p => !state.data.ailments.find(a => a._id === p._id))
        ],
        totalDocuments: {
          ...state.data.totalDocuments,
          ailments: totalDocuments
        },
      }
    })
  ),
  on(addAilment, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        ailments: [payload,
          ...(state.data.ailments.length === 10
            ? state.data.ailments.slice(0, state.data.ailments.length - 1)
            : state.data.ailments)],
        totalDocuments: {
          ...state.data.totalDocuments,
          ailments: state.data.totalDocuments.ailments + 1
        },
      }
    })
  ),
  on(editAilment, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        ailments: state.data.ailments.map(
          data => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removeAilments, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        ailments: state.data.ailments
          .filter(d => !payload.includes(String(d._id))),
        totalDocuments: {
          ...state.data.totalDocuments,
          ailments: state.data.totalDocuments.ailments - 1
        },
      }
    })
  ),
  on(removeAllAilments, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        ailments: [],
        totalDocuments: {
          ...state.data.totalDocuments,
          ailments: 0
        },
      }
    })
  ),

  // Pharmacy Test
  on(loadPharmacyTest, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        pharmacyServices: [
          ...state.data.pharmacyServices,
          ...payload.filter(p => !state.data.pharmacyServices.find(lt => lt._id === p._id))
        ],
        totalDocuments: {
          ...state.data.totalDocuments,
          pharmacyServices: totalDocuments
        },
      }
    })
  ),
  on(addPharmacyTest, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        pharmacyServices: [payload,
          ...(state.data.pharmacyServices.length === 10
            ? state.data.pharmacyServices.slice(0, state.data.pharmacyServices.length - 1)
            : state.data.pharmacyServices)],
        totalDocuments: {
          ...state.data.totalDocuments,
          pharmacyServices: state.data.totalDocuments.labTests + 1
        },
      }
    })
  ),
  on(editPharmacyTest, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        pharmacyServices: state.data.pharmacyServices.map(
          data => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removePharmacyTest, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        pharmacyServices: state.data.pharmacyServices
          .filter(d => !payload.includes(String(d._id))),
        totalDocuments: {
          ...state.data.totalDocuments,
          pharmacyServices: state.data.totalDocuments.labTests - 1
        },
      }
    })
  ),
  on(removeAllPharmacyTest, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        pharmacyServices: [],
        totalDocuments: {
          ...state.data.totalDocuments,
          pharmacyServices: 0
        },
      }
    })
  ),

  on(startInventoryFetch, (state) => ({
    ...state,
    fetching: true
  })),
  on(stopInventoryFetch, (state) => ({
    ...state,
    fetching: false
  })),
  on(paginateInventory, (state) => state)
);

export function reducer(state: InventoryStore, action: Action) {
  return inventoryReducer(state, action);
}
